import { render } from "./VendorOrdersShowCardPaymentsTable.vue?vue&type=template&id=d68bdc84"
import script from "./VendorOrdersShowCardPaymentsTable.vue?vue&type=script&lang=js"
export * from "./VendorOrdersShowCardPaymentsTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__